import './central.css';

/**
 * A SUBNAV DO MÓDULO VENDAS (telas 13 e 14): "uma entrada na sidebar — Vendas — e a subnav em
 * grupos". Nada de doze itens novos no menu principal. Análises por balconista, produtos e
 * horários (parte A/B da tela 15) dependem dos cupons do HOS com vendedor e chegam no Bloco 12.
 */

// Vendas é da LOJA (só o dono). Lançamentos e Conferência são do InovaPay e moram lá.
const ABAS: readonly { rota: string; rotulo: string; grupo?: 'CONTROLE'; cadeado?: boolean }[] = [
  { rota: 'vendas', rotulo: 'Visão geral' },
  { rota: 'movimentacao', rotulo: 'Movimentação' },
  { rota: 'devolucoes', rotulo: 'Devoluções' },
  { rota: 'excecoes', rotulo: 'Exceções' },
  { rota: 'pagamentos', rotulo: 'Pagamentos' },
  { rota: 'precos', rotulo: 'Preços & margem', cadeado: true },
];

export function SubnavDeVendas({
  atual,
  excecoes,
  direita,
}: {
  atual: string;
  excecoes?: number | undefined;
  direita?: string | undefined;
}) {
  return (
    <nav className="cv-subnav" aria-label="Vendas">
      {ABAS.map((a) => (
        <span key={a.rota} className="cv-subnav-item">
          {a.grupo && <span className="cv-subnav-grupo">{a.grupo}</span>}
          <a
            href={`#/${a.rota}`}
            className={atual === a.rota ? 'cv-sel' : ''}
            aria-current={atual === a.rota ? 'page' : undefined}
          >
            {a.rotulo}
            {a.rota === 'excecoes' && excecoes !== undefined && excecoes > 0 && (
              <span className="cv-contador">{excecoes}</span>
            )}
            {a.cadeado && (
              <svg
                width="11"
                height="11"
                viewBox="0 0 20 20"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                aria-label="área restrita"
              >
                <path d="M5.5 9h9v7.5h-9zM7.5 9V6.5a2.5 2.5 0 0 1 5 0V9" />
              </svg>
            )}
          </a>
        </span>
      ))}
      <span style={{ flex: 1 }} />
      {direita && <span className="cv-subnav-direita">{direita}</span>}
    </nav>
  );
}
